/**
 * This version now uses multi-slot transclusion. You specify the title by including a <ts-title> element and a subtitle
 * by including a <ts-subtitle> element.
 */
export const TitleAndSubtitleComponent = {
  bindings: {
    data: '<tsData',
    icon: '<tsIcon',
    popover: '<tsPopover'
  },
  transclude: {
    title: '?tsTitle',
    subtitle: '?tsSubtitle'
  },
  template: `<div class="titleAndSubtitle">
               <div>
                 <div class="title">
                   <icon-with-hover icon="$ctrl.icon" hover="$ctrl.popover" ng-if="$ctrl.icon"></icon-with-hover>
                   <h1 ng-transclude="title"></h1>
                 </div>
                 <div ng-transclude="subtitle"></div>
               </div>
               <div ng-transclude></div>
             </div>`
};
